





















import ActionButton from '@/components/ActionButton.vue'
import Card from '@/components/Card.vue'
import CategoriesCrudDialog from '@/components/Services/Deliveries/CategoriesCrudDialog.vue'
import { TableHeader } from '@/utils/interfaces'
import { tableHandler } from '@/utils/mixins/tableHandler'

export default tableHandler().extend({
  components: { Card, ActionButton, CategoriesCrudDialog },
  data() {
    return {
      getter: () => ({ response: { data: { results: [] } } }),
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('created_at'),
          value: 'created_at',
        },
      ] as TableHeader[],
    }
  },
})
